<template>
  <v-app>
    <v-row class="locale">
      <v-col>
        <switch-locale></switch-locale>
      </v-col>
    </v-row>
    <div class="login-header">
      <v-row>
        <v-col class="pt-5">
          <img src="@/assets/logo-akiem.svg" height="50" alt="logo" />
        </v-col>
      </v-row>
    </div>
    <div class="main">
      <div class="login-form">

        <div class="welcome-text">
          <p style="margin-bottom: 0px">
            {{ $t("message.login.welcomeFirst") }}
          </p>

          <img src="@/assets/mfh.svg" height="100" alt="logo" />
        </div>

        <div>
          <div v-if="!offline">
            <v-text-field
              outlined
              dense
              color="#00475A"
              :label="$t('message.login.id', { value: 'default' })"
              append-icon="mdi-account-circle"
              v-model="user"
              @keyup="submitForm"
            ></v-text-field>

            <v-text-field
              outlined
              dense
              color="#00475A"
              :label="$t('message.login.pw', { value: 'default' })"
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              v-model="pw"
              :type="show ? 'text' : 'password'"
              hide-details
              class="pb-1 pp"
              @click:append="show = !show"
              @keyup="submitForm"
            ></v-text-field>

            <div class="text-center" v-show="this.loginFailed">
              <v-alert color="red" text dense>
                {{ $t("message.login.errorLogin", { value: "default" }) }}
              </v-alert>
            </div>
            <div>
              <a
                href="#"
                style="
                  color: #7b766a;
                  text-decoration: underline;
                  font-size: 12px;
                "
                @click="dialog = true"
              >
                {{ $t("message.login.restore", { value: "default" }) }}
              </a>
            </div>

            <div class="pt-4">
              <v-btn @click="login()" color="#00475A" block dark type="submit">
                {{ $t("message.login.validate", { value: "default" }) }}
              </v-btn>
            </div>
          </div>
          <div class="welcome-text" v-if="offline">
            <v-icon size="102">mdi-connection</v-icon>
            <!--<h1>{{ $t("message.offline", { value: "default" }) }}</h1>-->
            <h4>
              Under maintenance, please contact your responsible fleet manager
              at Akiem technik
            </h4>
          </div>
          <!-- SSO button -->
          <div class="pt-4">
            <v-divider class="mt-3 mb-3"></v-divider>
            <v-btn color="primary" block :href="loginUrl">
              {{ $t("message.ssoLogin", { value: "default" }) }}
              <v-icon class="ml-3"> mdi-microsoft-azure </v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div class="notice">{{ $t("message.rgpd", { value: "default" }) }}</div>
    </div>

    <!--reset password Dialog-->
    <v-dialog v-model="dialog" max-width="500">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="headline">
            Reinitialisation de mot de passe
          </v-card-title>

          <v-card-text>
            <v-alert dense text :type="dtype" dismissible v-model="alert">
              {{ dmessage }}
            </v-alert>

            <div>
              Cette fonctionnalité n'est pas disponible pour les utilisateurs
              Active Directory
            </div>
            <br />

            <v-text-field
              outlined
              dense
              :rules="rules"
              color="#00475A"
              label="Votre e-mail"
              append-icon="mdi-email"
              v-model="resetAccount"
            ></v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="close"> Fermer </v-btn>

            <v-btn
              color="green darken-1"
              text
              @click="reset"
              :disabled="!valid"
            >
              Reinitialiser
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-app>
</template>

<script>
import SwitchLocale from "@/components/SwitchLocale";
import { mapActions, mapGetters } from "vuex";
import LoginService from "@/services/LoginService";
import { getTimelineDefaultPeriod } from "@/shared/DateHelper";

export default {
  name: "LoginPage",
  data() {
    return {
      valid: true,
      account: undefined,
      alert: false,
      offline: false,
      dtype: "",
      dmessage: "",
      rules: [
        (value) => !!value || "This field is required",
        (value) => /.+@.+\..+/.test(value) || "E-mail must be valid",
      ],
      user: "",
      dclass: "",
      pw: "",
      resetAccount: "",
      loginFailed: false,
      dialog: false,
      show: false,
    };
  },

  mounted() {
    this.maintenance();
    /* const accounts = this.$msalInstance.getAllAccounts();
    if (accounts.length == 0) {
      return;
    }
    this.account = accounts[0];
    this.$emitter.emit("login", this.account);*/
  },

  methods: {
    ...mapActions("auth", {
      actionLogin: "login",
      actionGetClients: "loadClients",
      actionGetContrats: "loadContrats",
    }),

    ...mapActions("carpet", {
      actionGetHistories: "loadHistories",
      actionGetAssets: "loadAssets",
      actionGetWos: "loadWos",
      actionGetSrs: "loadSrs",
    }),

    close() {
      this.dialog = false;
      this.resetAccount = "";
      this.alert = false;
      this.valid = true;
    },

    maintenance() {
      LoginService.isMaintenance().then((response) => {
        if (response.data.value == "ON") {
          this.offline = true;
        }
      });
    },

    reset() {
      if (this.$refs.form.validate()) {
        LoginService.resetLink({ mail: this.resetAccount })
          .then(() => {
            this.dtype = "success";
            this.dmessage =
              "Un lien de reinitialisation vous a été envoyé par mail";
            this.valid = false;
            this.alert = true;
          })
          .catch((error) => {
            this.dmessage = error.response.data;
            this.dtype = "error";
            this.alert = true;
          });
      }
    },

    submitForm: function (e) {
      if (e.keyCode == 13) {
        this.login();
      }
    },

    async login() {
      await this.actionLogin({ username: this.user, password: this.pw });
      if (this.getterLoginStatus === "success") {
        if (this.getterAdUser === true) {
          await this.actionGetClients();
        }
        if (this.getterCurrentClient != "") {
          await this.actionGetContrats(this.getterCurrentClient);

          this.actionGetHistories(this.getterCurrentClient);
          this.actionGetWos({
            customer: this.getterCurrentClient,
            start: getTimelineDefaultPeriod().start,
            end: getTimelineDefaultPeriod().end,
          });
        }

        //this.$matomo.setUserId(this.getterUserId)
        this.$router.push("/");
      } else {
        this.loginFailed = true;
      }
    },
  },
  computed: {
    ...mapGetters("auth", {
      getterLoginStatus: "getLoginStatus",
      getterAdUser: "isAdUser",
      getterUserId: "getUserId",
      getterCurrentClient: "getCurrentClient",
    }),

    loginUrl() {
      return process.env.VUE_APP_BASE_URL;
    },

    ...mapGetters("sso", {
      getterMsalConfig: "getMsalConfig",
    }),
  },
  components: {
    SwitchLocale,
  },
};
</script>

<style scoped>
.login-header {
  margin: 0px auto;
  background-color: #fff;
  display: inline-flex;
}

.notice {
  margin: 0px auto;
  width: 900px;
  font-size: 0.8em;
  color: #9faaaf;
  position: relative;
}

.err {
  color: #e53935;
  font-weight: bold;
}

.locale {
  position: absolute;
  right: 20px;
  top: 9px;
  width: 110px;
}

.main {
  background: url("../assets/background-login.jpg");
  background-size: cover;
  width: 100%;
  height: 100%;
  display: table;
}

.login-form {
  margin: 150px auto;
  padding: 42px 79px 52px 79px;
  background: #fff;
  display: block;
  width: 565px;
}

.welcome-text {
  text-align: center;
  font: normal normal normal 1.8em Calibri;
  color: #00475a;
  margin: 0px;
  text-transform: uppercase;
  /* margin-bottom: 52px;*/
}

.pp > .theme--light.v-icon {
  color: #00475a;
}

p {
  padding: 0px;
  margin: 0px;
}

.v-btn {
  color: #fff;
}

a {
  color: #7b766a;
}
</style>
